export default __webpack_public_path__ + "static/media/icon-more.51798eae.svg";